export default __webpack_public_path__ + "static/bckgrnd-bde423b819c06302e7ada3febdd852fa.jpg";